module.exports = __webpack_public_path__ + "img/3.c2c1bcc2.png";